// Centralized "where is this video being watched from?" helper.
// Returns { type: "curation" | "learning_path" | "course" | "video", id?: number }

export function getViewingContextFromUrl(href = window.location.href) {
  const url = new URL(href);
  const { pathname, searchParams } = url;

  // Query param takes precedence (e.g., embedded videos on a Curation page)
  const queryCurationId = searchParams.get("curation_id");
  if (queryCurationId) {
    const id = parseInt(queryCurationId, 10);
    if (Number.isFinite(id) && id > 0) return { type: "curation", id };
  }

  const matchId = (response) => {
    const match = pathname.match(response);
    if (!match) return undefined;
    const id = Number.parseInt(match[1], 10);
    return Number.isFinite(id) && id > 0 ? id : undefined;
  };

  const learningPathId = matchId(/\/paths\/(\d+)-/);
  if (learningPathId) return { type: "learning_path", id: learningPathId };

  const courseId = matchId(/\/(?:courses|classes)\/(\d+)-/);
  if (courseId) return { type: "course", id: courseId };

  const curationId = matchId(/\/curations\/(\d+)-/);
  if (curationId) return { type: "curation", id: curationId };

  // Default: standalone lesson page
  return { type: "video" };
}
